import { Hexagon } from "@/ui/Hexagon";
import { Parallax } from "react-scroll-parallax";

export default function ({ children, ...props }) {
  return (
    <Parallax {...props}>
      <Hexagon>
        <>{children}</>
      </Hexagon>
    </Parallax>
  );
}
